import { Ferme } from './../models/ferme.model';
import { Injectable } from '@angular/core';

interface IUser {
    id: number;
    ferme:Ferme
  }
  
  @Injectable()
  export class CurrentUserService {
    user: IUser;
  }